// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Ab17","notes":"Notes_notes__2P7D6"};